export const stepConfig = [
  {target: '.settingsWorkspaceName', key: 'workspaceName'},
  {target: '.settingsWorkspaceLogo', key: 'workspaceLogo'},
  {target: '.settingsWorkspacePrimaryColor', key: 'workspacePrimaryColor'},
  {target: '.settingsWorkspaceSecondaryColor', key: 'workspaceSecondaryColor'},
  {target: '.settingsLlmProvider', key: 'llmProvider'},
];
